(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-cooler"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shipping-cooler-container').forEach(container => {
    const vendorType = container.getAttribute('data-vendor-type');

    // Set background color of the container
    let backgroundColor;
    switch (vendorType) {
      case 'Dakota Organic':
        backgroundColor = 'var(--color-meyer-green-organic)';
        break;
      case 'Kuro American Wagyu':
        backgroundColor = 'var(--color-meyer-red)';
        break;
      case "Laura's Lean":
        backgroundColor = 'var(--color-meyer-green-confirmation)';
        break;
      default:
        backgroundColor = 'var(--color-meyer-angus)';
    }
    container.style.backgroundColor = backgroundColor;

    // Set text color of the "Learn More" link
    const link = container.querySelector('.learn-more');
    if (link) {
      let linkColor;
      switch (vendorType) {
        case 'Dakota Organic':
        case "Laura's Lean":
        case 'Kuro American Wagyu':
          linkColor = 'var(--color-meyer-meyer-prime)';
          break;
        default:
          linkColor = 'var(--color-meyer-main-text)';
      }
      link.style.color = linkColor;
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
